import { gql } from '@apollo/client'

export const FETCH_COACH_SWITCHING_SUMMARY = gql`
  query coachSwitchingSummary($coachId: ID!, $selectedSlot: String, $recurring: Boolean) {
    coachSwitchingSummary(coachId: $coachId, selectedSlot: $selectedSlot, recurring: $recurring) {
      reschedulableAppointments {
        id
        meetingAt
        kind
      }
      nonReschedulableAppointments {
        id
        meetingAt
        kind
      }
      recurringSlots
    }
  }
`
